"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutorestExtensionRpcHost = void 0;
const path_1 = require("path");
const vscode_jsonrpc_1 = require("vscode-jsonrpc");
const extension_logger_1 = require("./extension-logger");
const types_1 = require("./types");
var IAutoRestPluginInitiatorTypes;
(function (IAutoRestPluginInitiatorTypes) {
    IAutoRestPluginInitiatorTypes.ReadFile = new vscode_jsonrpc_1.RequestType2("ReadFile");
    IAutoRestPluginInitiatorTypes.GetValue = new vscode_jsonrpc_1.RequestType2("GetValue");
    IAutoRestPluginInitiatorTypes.ListInputs = new vscode_jsonrpc_1.RequestType2("ListInputs");
    IAutoRestPluginInitiatorTypes.ProtectFiles = new vscode_jsonrpc_1.NotificationType2("ProtectFiles");
    IAutoRestPluginInitiatorTypes.WriteFile = new vscode_jsonrpc_1.NotificationType4("WriteFile");
    IAutoRestPluginInitiatorTypes.Message = new vscode_jsonrpc_1.NotificationType2("Message");
})(IAutoRestPluginInitiatorTypes || (IAutoRestPluginInitiatorTypes = {}));
class AutorestExtensionRpcHost {
    constructor(channel, sessionId) {
        this.channel = channel;
        this.sessionId = sessionId;
        this.logger = new extension_logger_1.AutorestExtensionLogger((x) => this.message(x));
    }
    /**
     * Protect files that will not be cleared when using clear-output-folder.
     * @param path Path to the file/folder to protect.
     */
    async protectFiles(path) {
        this.channel.sendNotification(IAutoRestPluginInitiatorTypes.ProtectFiles, this.sessionId, path);
    }
    async readFile(filename) {
        return await this.channel.sendRequest(IAutoRestPluginInitiatorTypes.ReadFile, this.sessionId, filename);
    }
    /**
     * Get a configuration key form the resolved configuration.
     * @param key Path to the configuration entry. (Keys dot seperated)
     * @returns Value of the configuration.
     */
    async getValue(key) {
        return await this.channel.sendRequest(IAutoRestPluginInitiatorTypes.GetValue, this.sessionId, key);
    }
    /**
     * List inputs
     * @param artifactType @optional Filter by artifact type.
     * @returns name of the input files.
     */
    async listInputs(artifactType) {
        return await this.channel.sendRequest(IAutoRestPluginInitiatorTypes.ListInputs, this.sessionId, artifactType);
    }
    /**
     * Write a file.
     */
    writeFile({ filename, content, sourceMap, artifactType }) {
        if (artifactType) {
            this.channel.sendNotification(IAutoRestPluginInitiatorTypes.Message, this.sessionId, {
                Channel: types_1.Channel.File,
                Details: {
                    content: content,
                    type: artifactType,
                    uri: filename,
                    sourceMap: sourceMap,
                },
                Text: content,
                Key: [artifactType, filename],
            });
        }
        else {
            this.channel.sendNotification(IAutoRestPluginInitiatorTypes.WriteFile, this.sessionId, filename, content, sourceMap);
        }
    }
    /**
     * Send a message.
     * @param message Message to send.
     */
    message(message) {
        this.channel.sendNotification(IAutoRestPluginInitiatorTypes.Message, this.sessionId, message);
    }
    /**
     * @deprecated
     */
    WriteFile(filename, content) {
        return this.writeFile({ filename, content });
    }
    /**
     * @deprecated
     */
    GetValue(key) {
        return this.getValue(key);
    }
    /**
     * @deprecated
     */
    Message(message) {
        return this.message(message);
    }
    /**
     * @deprecated
     */
    UpdateConfigurationFile(filename, content) {
        this.channel.sendNotification(IAutoRestPluginInitiatorTypes.Message, this.sessionId, {
            Channel: types_1.Channel.Configuration,
            Key: [filename],
            Text: content,
        });
    }
    /**
     * @deprecated
     */
    async GetConfigurationFile(filename) {
        const configurations = await this.channel.sendRequest(IAutoRestPluginInitiatorTypes.GetValue, this.sessionId, "configurationFiles");
        const filenames = Object.getOwnPropertyNames(configurations);
        if (filenames.length > 0) {
            const basePath = (0, path_1.dirname)(filenames[0]);
            for (const configFile of filenames) {
                if (configFile.startsWith(basePath) && filename === (0, path_1.basename)(configFile)) {
                    return configurations[configFile];
                }
            }
        }
        return "";
    }
}
exports.AutorestExtensionRpcHost = AutorestExtensionRpcHost;
//# sourceMappingURL=extension-host.js.map